import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { ProfileService } from '../../services/profile/profile.service';
import { Phone, Profile } from '../../models/profile.model';
import { FormsModule, NgModel } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { LazyNgxMaskModule } from '@app/utils/forLazyRoot';
import { CommonModule } from '@angular/common';
import { AuthService, LabsService } from '../../services';
import { ButtonLoadingDirectiveModule } from '../../directives/button-loading.directive';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-phone',
  templateUrl: './confirm-phone.component.html',
  styleUrls: ['./confirm-phone.component.scss']
})
export class ConfirmPhoneComponent implements OnInit {

  @ViewChild('phone_form') phone_form;
  loading: boolean = false; 
  phone: Phone = {
    id: '',
    number: '',
    country:  'US',
    type: 1,
    primary: false,
    confirmed: false,
    confirmed_date: null,
  };
  phoneSubstring = "";
  step = 1
  confrimation_code = ''
  profileData: Profile = {
    id: '',
    first_name: '',
    last_name: '',
    birth_date: undefined,
    ssn: '',
    partial_ssn: '',
    national_identifier: '',
    ethnicity: 0,
    gender: 1,
    abartys_id: '',
    tags: [],
    addresses: [],
    emails: [],
    phones: [],
    health_plans_cards: [],
    all_health_plans_cards: [],
    sms_notify: false
  }
  errorCodes = [];

  constructor(private auth: AuthService, private api: ApiService, public profile: ProfileService, private modalService: NgbModal, public labs: LabsService){}

  ngOnInit() {
    // const { phones } = this.profile.getValue();
    // this.phone = phones?.find(phone => phone.primary) || phones?.[0];

    if (this.phone.number == '') {
      this.api.getProfile().subscribe((data) => {
        console.log("data", data);
        
        this.profileData = data

        this.profileData.phones.forEach((phone) => {
          phone.number = phone.number.replace('+1', '')
        })

        if (this.profileData.phones.length == 0) {
          let newPhone = new Phone('');
          newPhone.primary = true
          this.profileData.phones.push(newPhone)
        }
      })
    }
  }

  onLogout() {
    this.auth.logout().subscribe();
  }

  sendCode() {
    let phone = this.profileData.phones?.find(phone => phone.primary);

    this.phoneSubstring = phone.number.slice(phone.number.length - 4);

    console.log("phoneSubstring", this.phoneSubstring);

    const data = {
      method: 'autodetect',
      sms_notify:true,
      phone_number: phone.number
    };

    this.api.addResultsByPhone(data).subscribe((data) => {
    }, (error) => {
      console.log("error", error);
    });
  }

  submitPhone() {
    this.loading = true;
    const { id, phones = [] } = this.profileData;

    if (phones[0].primary && phones[0].number.length  == 0) {
      this.loading = false;
      return;
    }

    this.api.editProfile({
      phones: [...phones]
    }, id).subscribe((data) => {
      this.loading = false;
      this.profile.refresh();
      this.step = 2;
      this.sendCode()
      console.log("data", data);
    }, (error) => {
      this.loading = false;
    });
  }

  sendConfirmationCode(){
    this.errorCodes = []
    this.loading = true;

    let phone = this.profileData.phones?.find(phone => phone.primary);

    let data = {
      verification_code: this.confrimation_code,
      phone_number: phone.number,
      sms_notify: true
    }

    this.api.checkLabsByCode(data).subscribe(() => {
      this.loading = false;
      this.profile.refresh();
      this.labs.refresh();
      this.step = 3;
    }, (error) => {
      this.loading = false;
      this.errorCodes = error.error.error
    })
  }

  closeModal(){
    this.modalService.dismissAll();
    return;
  }
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslocoModule,
    LazyNgxMaskModule,
    ButtonLoadingDirectiveModule
  ],
  declarations: [ConfirmPhoneComponent],
  exports: [ConfirmPhoneComponent]
})
export class ConfirmPhoneComponentModule {}